export default __webpack_public_path__ + "static/img/le-tinte-logo-brown.7537c3b.png";